import React from 'react';
import { RedocStandalone } from 'redoc';

import empdocs from './empdocs.json';

function EmpDocs() {
    return (
        <div>
            <RedocStandalone spec={empdocs} options={{ scrollYOffset: 100 }} />
        </div>
    );
}

export default EmpDocs;
